import { Temporal } from "temporal-polyfill";

// Picked b/c 2018-01-01 is a Monday :shrug:
// https://www.timeanddate.com/calendar/monthly.html?year=2018&month=1&country=1
export const jan1 = Temporal.PlainDate.from("2018-01-01");
export const jan2 = Temporal.PlainDate.from("2018-01-02");
export const jan3 = Temporal.PlainDate.from("2018-01-03");
export const jan4 = Temporal.PlainDate.from("2018-01-04");
export const jan5 = Temporal.PlainDate.from("2018-01-05");
export const jan6 = Temporal.PlainDate.from("2018-01-06");
export const jan7 = Temporal.PlainDate.from("2018-01-07");
export const jan8 = Temporal.PlainDate.from("2018-01-08");
export const jan9 = Temporal.PlainDate.from("2018-01-09");
export const jan10 = Temporal.PlainDate.from("2018-01-10");
export const jan11 = Temporal.PlainDate.from("2018-01-11");
export const jan12 = Temporal.PlainDate.from("2018-01-12");
export const jan13 = Temporal.PlainDate.from("2018-01-13");
export const jan14 = Temporal.PlainDate.from("2018-01-14");
export const jan15 = Temporal.PlainDate.from("2018-01-15");
export const jan16 = Temporal.PlainDate.from("2018-01-16");
export const jan17 = Temporal.PlainDate.from("2018-01-17");
export const jan18 = Temporal.PlainDate.from("2018-01-18");
export const jan19 = Temporal.PlainDate.from("2018-01-19");
export const jan20 = Temporal.PlainDate.from("2018-01-20");
export const jan21 = Temporal.PlainDate.from("2018-01-21");
export const jan22 = Temporal.PlainDate.from("2018-01-22");
export const jan23 = Temporal.PlainDate.from("2018-01-23");
export const jan25 = Temporal.PlainDate.from("2018-01-25");
export const jan28 = Temporal.PlainDate.from("2018-01-28");
export const jan29 = Temporal.PlainDate.from("2018-01-29");
export const jan31 = Temporal.PlainDate.from("2018-01-31");
export const feb1 = Temporal.PlainDate.from("2018-02-01");
export const feb4 = Temporal.PlainDate.from("2018-02-04");
export const feb25 = Temporal.PlainDate.from("2018-02-25");
export const dec4 = Temporal.PlainDate.from("2017-12-04");
export const dec18 = Temporal.PlainDate.from("2017-12-18");
export const dec25 = Temporal.PlainDate.from("2017-12-25");
export const dec29 = Temporal.PlainDate.from("2017-12-29");
export const dec31 = Temporal.PlainDate.from("2017-12-31");
export const dec25_2024 = Temporal.PlainDate.from("2024-12-25");
export const jan1Midnight = atMidnight(jan1);
export const jan2Midnight = atMidnight(jan2);
export const jan10Midnight = atMidnight(jan10);
export const jan15Midnight = atMidnight(jan15);
export const jan19Midnight = atMidnight(jan19);
export const jan1_3000 = Temporal.PlainDate.from("3000-01-01");

/** A function specifically for graphqlFactories to get new dates. */
export function newDate() {
  return jan1;
}

/** A function specifically for graphqlFactories to get new date times. */
export function newDateTime() {
  return jan1Midnight;
}

/** Sets the vitest system clock from a Temporal value. */
export function setSystemTime(date: Temporal.PlainDate | Temporal.ZonedDateTime) {
  if (date instanceof Temporal.PlainDate) {
    vi.setSystemTime(date.toPT().toLegacyDate());
  } else {
    vi.setSystemTime(date.epochMilliseconds);
  }
}

export function atMidnight(date: Temporal.PlainDate | Temporal.ZonedDateTime) {
  const plainDate = date instanceof Temporal.PlainDate ? date : date.toPlainDate();
  return Temporal.Instant.from(`${plainDate}T00:00:00.000Z`).toZonedDateTimeISO("UTC");
}
